import { HeadingProps } from "../../Types/CommonElementType";

const H5: React.FC<HeadingProps> = (props) => {
  return (
    <h5 {...props} style={props.style}>
      {props.children}
    </h5>
  );
};
export default H5;
